<template>
  <ControlCommonLayout header="controlHeader" footer="controlFooter">
    <b-overlay :show="overlayShow" rounded="sm">
      <div class="container">
        <div class="main-color text-light row mt-3">
          <div class="col p-2">
            スペック一覧
          </div>
        </div>

        <div id="search-box" class="row mt-3 base-color">
          <div class="accordion col p-0" role="tablist">
            <b-card no-body>
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block v-b-toggle.accordion-1 id='search-bar' class="light-blue text-left text-black" @click="changeIcon()"><b-icon id="icon-up" icon="chevron-up"></b-icon><b-icon id="icon-down" class="hide" icon="chevron-down"></b-icon>&nbsp;検索条件</b-button>
              </b-card-header>
              <!-- 制作案件一覧検索BOX -->
              <b-collapse visible id="accordion-1" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <form method="post" action="#" class="form-horizontal">
                    <div class="form-group row">
                      <div class="col-sm-3">
                        <label for="name" class="control-label col-sm-12">ID</label>
                        <div class="col-sm-12 pr-0">
                          <input type="text" id="project-number" class="form-control input-sm search-spec-condition" v-model="searchProjectNumber"/>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <label for="name" class="control-label col-sm-12">スタイル</label>
                        <div class="col-sm-12 pr-0">
                          <select id="style" class="form-control input-sm search-spec-condition" v-model="searchStyle">
                            <option value="">選択してください</option>
                            <option v-for="(style, index) in getStyles()" :key="index + 'style'" :value="style['スタイル']['value']">{{style['スタイル']['value']}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <label for="name" class="control-label col-sm-12">色</label>
                        <div class="col-sm-12 pr-0">
                          <select id="color" class="form-control input-sm search-spec-condition" v-model="searchColor">
                            <option value="">選択してください</option>
                            <option v-for="(color, index) in getColors()" :key="index + 'color'" :value="color['名称']['value']">{{color['名称']['value']}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <label for="name" class="control-label col-sm-12">季節</label>
                        <div class="col-sm-12 pr-0">
                          <select id="season" class="form-control input-sm search-spec-condition" v-model="searchSeason">
                            <option value="">選択してください</option>
                            <option v-for="(season, index) in getSeasons()" :key="index + 'season'" :value="season['名称']['value']">{{season['名称']['value']}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-3">
                        <label for="name" class="control-label col-sm-12">案件フラグ ※複数選択可</label>
                        <div class="col-sm-12 pr-0">
                          <v-select id="ankenFlg" class="input-sm search-spec-condition" :options="ankenFlgOptions" v-model="searchAnkenFlg" name="ankenFlg" :close-on-select="false" :deselectFromDropdown="true" multiple></v-select>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <label for="name" class="control-label col-sm-12">ユニット</label>
                        <div class="col-sm-12 pr-0">
                          <input type="text" id="unit" class="form-control input-sm search-spec-condition" v-model="searchUnit"/>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <label for="name" class="control-label col-sm-12">施設コード</label>
                        <div class="col-sm-12 pr-0">
                          <input type="text" id="facilityCode" class="form-control input-sm search-spec-condition" v-model="searchFacilityCode" @blur="autoChangeFacility"/>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <label for="name" class="control-label col-sm-12">施設名</label>
                        <div class="col-sm-12 pr-0">
                          <input type="text" id="facilityName" class="form-control input-sm search-spec-condition" v-model="searchFacilityName"/>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 pr-0">
                        <div class="row" style="margin-left: 0px">
                          <label class="control-label col-sm-12">施行日</label>
                          <div class="col-sm-5 pr-0">
                            <input type="date" id="construction-date-from" class="form-control input-sm search-spec-condition" v-model="searchConstructionDateFrom"/>
                          </div>
                          <div class="col-sm-1 p-0 mt-2 text-center">
                            <span>〜</span>
                          </div>
                          <div class="col-sm-5 pl-0">
                            <input type="date" id="construction-date-to" class="form-control input-sm search-spec-condition" v-model="searchConstructionDateTo"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4 pr-0">
                        <div class="row" style="margin-left: 0px">
                          <label class="control-label col-sm-12">メインテーブル合計金額</label>
                          <div class="col-sm-5 pr-0">
                            <input type="text" id="main-price-from" class="form-control input-sm search-spec-condition" v-model="searchMainPriceFrom"/>
                          </div>
                          <div class="col-sm-1 p-0 mt-2 text-center">
                            <span>〜</span>
                          </div>
                          <div class="col-sm-5 pl-0">
                            <input type="text" id="main-price-to" class="form-control input-sm search-spec-condition" v-model="searchMainPriceTo"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <label for="name" class="control-label col-sm-12">メイン形状 ※複数選択可</label>
                        <div class="col-sm-12 pr-0">
                          <v-select id="mainShape" class="input-sm search-spec-condition" v-model="searchMainShape" :options="mainShapeData" :value="searchMainShape" :reduce="options => options.value" name="mainShape" :close-on-select="false" :deselectFromDropdown="true" append-to-body multiple>
                          </v-select>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 pr-0">
                        <div class="row" style="margin-left: 0px">
                          <label class="control-label col-sm-12">作成日</label>
                          <div class="col-sm-5 pr-0">
                            <input type="date" id="make-date-from" class="form-control input-sm search-spec-condition" v-model="searchMakeDateFrom"/>
                          </div>
                          <div class="col-sm-1 p-0 mt-2 text-center">
                            <span>〜</span>
                          </div>
                          <div class="col-sm-5 pl-0">
                            <input type="date" id="make-date-to" class="form-control input-sm search-spec-condition" v-model="searchMakeDateTo"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4 pr-0">
                        <div class="row" style="margin-left: 0px">
                          <label class="control-label col-sm-12">ゲストテーブル合計金額</label>
                          <div class="col-sm-5 pr-0">
                            <input type="text" id="guest-price-from" class="form-control input-sm search-spec-condition" v-model="searchGuestPriceFrom"/>
                          </div>
                          <div class="col-sm-1 p-0 mt-2 text-center">
                            <span>〜</span>
                          </div>
                          <div class="col-sm-5 pl-0">
                            <input type="text" id="guest-price-to" class="form-control input-sm search-spec-condition" v-model="searchGuestPriceTo"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <label for="name" class="control-label col-sm-12">ゲスト形状 ※複数選択可</label>
                        <div class="col-sm-12 pr-0">
                          <v-select id="guestShape" class="input-sm search-spec-condition" v-model="searchGuestShape" :options="guestShapeData" :reduce="options => options.value" name="guestShape" :close-on-select="false" :deselectFromDropdown="true" append-to-body multiple>
                          </v-select>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 pr-0">
                        <div class="row" style="margin-left: 0px">
                          <label class="control-label col-sm-12">更新日</label>
                          <div class="col-sm-5 pr-0">
                            <input type="date" id="update-date-from" class="form-control input-sm search-spec-condition" v-model="searchUpdateDateFrom"/>
                          </div>
                          <div class="col-sm-1 p-0 mt-2 text-center">
                            <span>〜</span>
                          </div>
                          <div class="col-sm-5 pl-0">
                            <input type="date" id="update-date-to" class="form-control input-sm search-spec-condition" v-model="searchUpdateDateTo"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <label for="name" class="control-label col-sm-12">状態</label>
                        <div class="col-sm-12 pr-0">
                          <select id="display" class="form-control input-sm search-spec-condition" v-model="searchDisplay">
                            <option value="">すべて</option>
                            <option v-for="(display, index) in getDisplay()" :key="index + 'display'" :value="display">{{display}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="text-center mt-4">
                      <b-button variant="outline-secondary" type="button" class="w-25 white-btn" @click="clearConditions">検索条件をクリア</b-button>
                      <b-button class="main-color text-light w-25 ml-3" @click="searchSpec()">検索</b-button>
                    </div>
                  </form>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>

        <!-- スペック一覧リスト -->
        <div class="row mt-3 base-color">
          <b-overlay :show="overlaySpecListShow" rounded="sm" class="col-sm-12">
            <div class="col-sm-12 row pt-3 pr-0">
              <div class="col-sm-6">
                検索結果<span class="h3 ml-1">{{this.projectLength}}</span><span class="ml-1 mr-2">件</span>{{projectLength > 0 ? pageStart + 1 : 0}} - {{pageEnd}}件を表示
              </div>
              <div class="col-sm-6 text-right pr-0">
                <b-button variant="primary" @click="specRegist()" :disabled="!(userRoleMode == 2 || (userRoleMode == 1 && userEditAuthority))">新規登録</b-button>
              </div>
            </div>
            <div class="col-sm-12 mt-3">
              <b-table-simple bordered class="small">
                <thead role="rowgroup" class="table-bordered">
                  <tr role="row" class="align-middle">
                    <th rowspan="2" class="align-middle text-center" style="width: 5%;" @click="sortBy('レコード番号')">ID{{strSortDirection('打合せ参加ID')}}</th>
                    <th rowspan="2" class="align-middle text-center" style="width: 12%;">画像</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 9%;" @click="sortBy('スタイル')">スタイル{{strSortDirection('スタイル')}}</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 31%;" @click="sortBy('メイン形状')">メイン形状{{strSortDirection('メイン形状')}}</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 9%;" @click="sortBy('メインテーブル合計金額', 'num')">メイン金額{{strSortDirection('メインテーブル合計金額')}}</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 8%;" @click="sortBy('色')">色{{strSortDirection('色')}}</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 13%;" @click="sortBy('施工日')">施行日{{strSortDirection('施工日')}}</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 8%;" @click="sortBy('作成日時')">作成日{{strSortDirection('作成日時')}}</th>
                    <th rowspan="2" class="align-middle text-center" style="width: 5%;" @click="sortBy('案件ステータス')">状態{{strSortDirection('状態')}}</th>
                  </tr>
                  <tr>
                    <th class="align-middle text-center" @click="sortBy('案件フラグ')">案件フラグ{{strSortDirection('案件フラグ')}}</th>
                    <th class="align-middle text-center" @click="sortBy('ゲスト形状')">ゲスト形状{{strSortDirection('ゲスト形状')}}</th>
                    <th class="align-middle text-center" @click="sortBy('ゲストテーブル合計金額', 'num')">ゲスト金額{{strSortDirection('ゲストテーブル合計金額')}}</th>
                    <th class="align-middle text-center" @click="sortBy('季節')">季節{{strSortDirection('季節')}}</th>
                    <th class="align-middle text-center" @click="sortBy('施設コード')">施設コード 施設名{{strSortDirection('施設コード')}}</th>
                    <th class="align-middle text-center" @click="sortBy('更新日時')">更新日{{strSortDirection('更新日時')}}</th>
                  </tr>
                </thead>
                <template v-for="(project, index) in activeProjectList">
                  <b-tbody :key="index + 'tbody'" :class="index % 2 === 1 ? 'gray-line' : 'white-line'">
                    <b-tr :key="index + 'activeProject'">
                      <b-td :rowspan="2" class="align-middle" style="text-align: center;">
                        <a href="#" @click.prevent.stop="specChange(project['レコード番号']['value'])" target="_blank">{{project['レコード番号'] ? project['レコード番号']['value'] : ''}}</a>
                      </b-td>
                      <b-td :rowspan="2" class="align-middle" style="text-align: right;">
                        <img :src="project['画像ファイルパス']['value']" class="mw-100 tile-image-height" v-if="project['画像ファイルパス']['value'] !== ''">
                      </b-td>
                      <b-td class="align-middle">{{project['スタイル'] ? changeArrayFormat(project['スタイル']['value']) : ''}}</b-td>
                      <b-td class="align-middle" style="white-space: pre;">{{project['メイン形状'] ? changeToShapeName(project['メイン形状']['value'], 'main') : ''}}</b-td>
                      <b-td class="align-middle" style="text-align: right;">{{project['メインテーブル合計金額'] ? toCommaSeparated(project['メインテーブル合計金額']['value']) : '0'}}</b-td>
                      <b-td class="align-middle">{{project['色'] ? changeArrayFormat(project['色']['value']) : ''}}</b-td>
                      <b-td class="align-middle">{{project['施工日'] ? changeDateFormat(project['施工日']['value'], 'constructionDate') : ''}}</b-td>
                      <b-td class="align-middle">{{project['作成日時'] ? changeDateFormat(project['作成日時']['value']) : ''}}</b-td>
                      <b-td :rowspan="2" class="align-middle">
                        <div class="custom-control custom-switch text-center ml-2">
                          <input type="checkbox" class="custom-control-input" :id="'toggle-display' + index" :checked="project['案件ステータス']['value'] == '売上日報完了'" @change="changeToggle (index)" :disabled="userRoleMode !== 2">
                          <label class="custom-control-label" :for="'toggle-display' + index"></label>
                          <input name="projectNumber" :id="'project-number' + index" type="hidden" :value="project['レコード番号']['value']">
                        </div>
                      </b-td>
                    </b-tr>
                    <b-tr :key="index">
                      <b-td class="align-middle">{{project['案件フラグ'] ? project['案件フラグ']['value'] : ''}}</b-td>
                      <b-td class="align-middle" style="white-space: pre;">{{project['ゲスト形状'] ? changeToShapeName(project['ゲスト形状']['value'], 'guest') : ''}}</b-td>
                      <b-td class="align-middle" style="text-align: right;">{{project['ゲストテーブル合計金額'] ? toCommaSeparated(project['ゲストテーブル合計金額']['value']) : '0'}}</b-td>
                      <b-td class="align-middle">{{project['季節'] ? project['季節']['value'] : ''}}</b-td>
                      <b-td class="align-middle">{{project['施設コード'] ? project['施設コード']['value'] : ''}}<br>{{project['施設名'] ? project['施設名']['value'] : ''}}</b-td>
                      <b-td class="align-middle">{{project['更新日時'] ? changeDateFormat(project['更新日時']['value']) : ''}}</b-td>
                    </b-tr>
                  </b-tbody>
                </template>
              </b-table-simple>
            </div>
            <div class="col-sm-12 row pt-3 pr-0">
              <div class="col-sm-4">
                検索結果<span class="h3 ml-1">{{this.projectLength}}</span><span class="ml-1 mr-2">件</span>{{projectLength > 0 ? pageStart + 1 : 0}} - {{pageEnd}}件を表示
              </div>
              <div class="col-sm-4">
                <paginate
                  v-model="page"
                  :page-count="Math.ceil(projectLength / pageMaxNum)"
                  :page-range="3"
                  :margin-pages="2"
                  :click-handler="clickCallback"
                  :prev-text="'<'"
                  :next-text="'>'"
                  :container-class="'pagination justify-content-center'"
                  :page-class="'page-item'"
                  :page-link-class="'page-link'"
                  :prev-class="'page-item'"
                  :prev-link-class="'page-link'"
                  :next-class="'page-item'"
                  :next-link-class="'page-link'"
                  >
                </paginate>
              </div>
            </div>
          </b-overlay>
        </div>

      </div>
    </b-overlay>
    <CommonModal ref="commonModal" />
    <CommonModal ref="commonModalUpdateCancel" @confirmOk="specUpdateCancel" />
  </ControlCommonLayout>
</template>
<script>
import ControlCommonLayout from '@/layout/ControlCommonLayout'
import CommonModal from '@/components/CommonModal'
import SpecListModel from '@/models/SpecListModel'
import SearchSpecListModel from '@/models/SearchSpecListModel'
import SearchFacilityModel from '@/models/SearchFacilityModel'
import Vue from 'vue'
import Paginate from 'vuejs-paginate'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
Vue.component('paginate', Paginate)
Vue.component('v-select', vSelect)

export default {
  name: 'ControlSpecList',
  components: { ControlCommonLayout, CommonModal, SpecListModel, SearchSpecListModel },
  data () {
    return {
      overlayShow: false,
      overlaySpecListShow: false,
      searchProjectNumber: '',
      searchStyle: '',
      searchColor: '',
      searchSeason: '',
      searchMainPriceFrom: '',
      searchMainPriceTo: '',
      searchGuestPriceFrom: '',
      searchGuestPriceTo: '',
      searchMakeDateFrom: '',
      searchMakeDateTo: '',
      searchDisplay: '表示',
      searchAnkenFlg: ['1', '3', '1.5'],
      searchUnit: '',
      searchFacilityCode: '',
      searchFacilityName: '',
      searchMainShape: [],
      searchGuestShape: [],
      searchUpdateDateFrom: '',
      searchUpdateDateTo: '',
      searchConstructionDateFrom: '',
      searchConstructionDateTo: '',
      styleData: [],
      colorData: [],
      seasonData: [],
      mainShapeData: [],
      mainShapeDataForChange: [],
      guestShapeData: [],
      guestShapeDataForChange: [],
      userId: '',
      userRole: '',
      userRoleMode: '',
      userEditAuthority: false,
      toroku: false,
      activeProjectList: [],
      projectData: [],
      projectLength: 0,
      page: 1,
      pageMaxNum: 20,
      pageStart: 0,
      pageEnd: 0,
      projectNumberSortDirection: '',
      styleSortDirection: '',
      colorSortDirection: '',
      seasonSortDirection: '',
      mainPriceSortDirection: '',
      guestPriceSortDirection: '',
      makeDateSortDirection: '',
      displaySortDirection: '',
      ankenFlgSortDirection: '',
      mainShapeSortDirection: '',
      guestShapeSortDirection: '',
      constructionDateSortDirection: '',
      facilityCodeAndNameSortDirection: '',
      updateDateSortDirection: '',
      ankenFlgOptions: ['1', '1.5', '3', '5', '6', '7']
    }
  },
  methods: {
    setApiData: async function (isReload = false) {
      this.overlayShow = true
      console.log(this.$route.meta)
      console.log(this.$route.query)
      if (this.$route.meta.userId) {
        this.userId = this.$route.meta.userId
        localStorage.setItem('controlUserId', this.userId)
      } else {
        this.userId = localStorage.getItem('controlUserId')
        this.userRole = localStorage.getItem('controlUserRole')
        this.userEditAuthority = (localStorage.getItem('controlUserEditAuthority') !== 'false')
      }
      if (this.$route.meta.userId) {
        this.toroku = (this.$route.meta.toroku === 'true')
        localStorage.setItem('controlToroku', JSON.stringify(this.toroku))
      } else {
        this.toroku = (localStorage.getItem('controlToroku') === 'true')
      }
      console.log(this.userId)
      console.log(this.toroku)

      const result = await SpecListModel.getApi(this.$bvModal, null, () => {})
      console.log(result)
      if (result['style'] === undefined) {
        console.log('style:undefined')
      } else {
        this.styleData = result['style']
      }
      if (result['color'] === undefined) {
        console.log('color:undefined')
      } else {
        this.colorData = result['color']
      }
      if (result['season'] === undefined) {
        console.log('season:undefined')
      } else {
        this.seasonData = result['season']
      }
      if (result['tantosha'] === undefined) {
        console.log('tantosha:undefined')
      } else {
        for (const tantosha of result['tantosha']) {
          if (this.userId === tantosha['担当者コード']['value']) {
            this.userRole = tantosha['役割']['value']
            localStorage.setItem('controlUserRole', this.userRole)
            this.userEditAuthority = (tantosha['企画編集権限']['value'].length > 0)
            localStorage.setItem('controlUserEditAuthority', this.userEditAuthority)
            break
          }
        }
      }
      if (result['mainShape'] === undefined) {
        console.log('mainShape:undefined')
      } else {
        this.mainShapeData = result['mainShape']
      }
      if (result['guestShape'] === undefined) {
        console.log('guestShape:undefined')
      } else {
        this.guestShapeData = result['guestShape']
      }
      console.log(this.styleData)
      console.log(this.colorData)
      console.log(this.seasonData)
      console.log(this.userRole)
      console.log(this.userEditAuthority)

      // ユーザーの役割に応じたモード変更
      this.setUserRoleMode()
      console.log(this.userRoleMode)

      // 次画面から戻ってきたとき、検索条件の再設定、再検索、ページ移動を行う
      if (JSON.parse(localStorage.getItem('isPageBack'))) {
        console.log('pageback処理')
        await this.pageBackDataSetUp()
        if (localStorage.getItem('nowProjectListPage')) {
          // ページ番号があるとき（１回でも検索していた時）再検索を行う
          this.page = parseInt(localStorage.getItem('nowProjectListPage'), 10)
          this.searchSpec(this.page, true)
        }
        localStorage.removeItem('isPageBack')
      } else {
        scrollTo(0, 0)
        // 初期表示時、退避させていた入力情報を消す
        localStorage.removeItem('searchSpecConditions')
        localStorage.removeItem('nowProjectListPage')
      }

      this.overlayShow = false
    },
    toCommaSeparated (str) {
      if (str) {
        try {
          return parseInt(str, 10).toLocaleString()
        } catch (err) {
          return ''
        }
      }
      return str
    },
    changeDateFormat (date, type = '') {
      if (date === null) {
        return null
      }
      if (type === 'constructionDate') {
        date = date.replace('-', '/').replace('-', '/')
      } else {
        date = date.substring(0, date.indexOf('T')).replace('-', '/').replace('-', '/')
      }
      return date
    },
    changeArrayFormat (date) {
      if (date === null) {
        return null
      }

      return date.join('、')
    },
    changeIcon () {
      document.getElementById('icon-up').classList.toggle('hide')
      document.getElementById('icon-down').classList.toggle('hide')
    },
    getStyles () {
      return this.styleData
    },
    getColors () {
      return this.colorData
    },
    getSeasons () {
      return this.seasonData
    },
    getDisplay () {
      return ['表示', '非表示']
    },
    validate () {
      // 検索条件のチェックを追加する
      return true
    },
    searchSpec: async function (nowpage = 1, isPageBack = false, pageSortReset = true) {
      // 前画面から戻った時でなければ画面入力値のチェックを行う
      if (!isPageBack) {
        if (!this.validate()) {
          return false
        }
      }
      this.page = nowpage
      this.overlaySpecListShow = true

      // 入力値変換
      this.searchMainPriceFrom = this.searchMainPriceFrom.replace(',', '').replace(' ', '')
      this.searchMainPriceTo = this.searchMainPriceTo.replace(',', '').replace(' ', '')
      this.searchGuestPriceFrom = this.searchGuestPriceFrom.replace(',', '').replace(' ', '')
      this.searchGuestPriceTo = this.searchGuestPriceTo.replace(',', '').replace(' ', '')
      this.searchProjectNumber = this.searchProjectNumber.replace('，', ',')

      let params = {}
      if (this.searchProjectNumber !== '') {
        params['projectNumber'] = this.searchProjectNumber.split(',')
      }
      if (this.searchStyle !== '') {
        params['style'] = [this.searchStyle]
      }
      if (this.searchColor !== '') {
        params['color'] = [this.searchColor]
      }
      if (this.searchSeason !== '') {
        params['season'] = this.searchSeason
      }
      if (this.searchMainPriceFrom !== '') {
        params['mainPriceFrom'] = this.searchMainPriceFrom
      }
      if (this.searchMainPriceTo !== '') {
        params['mainPriceTo'] = this.searchMainPriceTo
      }
      if (this.searchGuestPriceFrom !== '') {
        params['guestPriceFrom'] = this.searchGuestPriceFrom
      }
      if (this.searchGuestPriceTo !== '') {
        params['guestPriceTo'] = this.searchGuestPriceTo
      }
      if (this.searchMakeDateFrom !== '') {
        params['makeDateFrom'] = this.searchMakeDateFrom
      }
      if (this.searchMakeDateTo !== '') {
        params['makeDateTo'] = this.searchMakeDateTo
      }
      if (this.searchDisplay !== '') {
        params['display'] = this.searchDisplay
      }
      if (this.searchAnkenFlg.length > 0) {
        params['ankenFlg'] = this.searchAnkenFlg
      }
      if (this.searchUnit !== '') {
        params['unit'] = this.searchUnit
      }
      if (this.searchFacilityCode !== '') {
        params['facilityCode'] = this.searchFacilityCode
      }
      if (this.searchFacilityName !== '') {
        params['facilityName'] = this.searchFacilityName
      }
      if (this.searchMainShape.length > 0) {
        params['mainShape'] = this.searchMainShape
      }
      if (this.searchGuestShape.length > 0) {
        params['guestShape'] = this.searchGuestShape
      }
      if (this.searchUpdateDateFrom !== '') {
        params['updateDateFrom'] = this.searchUpdateDateFrom
      }
      if (this.searchUpdateDateTo !== '') {
        params['updateDateTo'] = this.searchUpdateDateTo
      }
      if (this.searchConstructionDateFrom !== '') {
        params['constructionDateFrom'] = this.searchConstructionDateFrom
      }
      if (this.searchConstructionDateTo !== '') {
        params['constructionDateTo'] = this.searchConstructionDateTo
      }
      let projectData = await SearchSpecListModel.getApi(this.$bvModal, params, () => {})
      console.log(projectData)
      if (!projectData['specs'] || !projectData['specs']['records'] || projectData['status'] !== 'success') {
        console.log('スペック情報検索失敗')
        this.$refs.commonModal.msgBoxOk('スペック情報の検索に失敗いたしました。')
        this.overlaySpecListShow = false
        return false
      }
      this.projectData = projectData

      // 検索条件を保存
      let searchSpecConditions = {}
      this.projectLength = projectData['specs']['records'].length
      this.setActiveProjectList()

      // 画面項目の検索条件を保存
      if (!isPageBack) {
        const searchInputs = document.getElementsByClassName('search-spec-condition')
        for (const searchInput of searchInputs) {
          if (searchInput.id === 'ankenFlg') {
            searchSpecConditions[searchInput.id] = this.searchAnkenFlg
          } else if (searchInput.id === 'mainShape') {
            searchSpecConditions[searchInput.id] = this.searchMainShape
          } else if (searchInput.id === 'guestShape') {
            searchSpecConditions[searchInput.id] = this.searchGuestShape
          } else {
            searchSpecConditions[searchInput.id] = searchInput.value
          }
        }
        localStorage.setItem('searchSpecConditions', JSON.stringify(searchSpecConditions))
      }

      if (pageSortReset) {
        // ソートを初期化
        this.iniSortDirection()
      } else {
        this.sortKeep()
      }
      // トグルの初期化
      this.refreshToggel()

      this.overlaySpecListShow = false
    },
    setProjects: async function () {
      // 画面に表示している一覧をクリア
      this.activeProjectList = []
      // 検索結果を初期化
      this.resetProjects()
      // 検索条件を初期化
      this.clearConditions()
      // 1ページ目を表示
      this.page = 1
    },
    clearConditions () {
      this.searchProjectNumber = ''
      this.searchStyle = ''
      this.searchColor = ''
      this.searchSeason = ''
      this.searchMainPriceFrom = ''
      this.searchMainPriceTo = ''
      this.searchGuestPriceFrom = ''
      this.searchGuestPriceTo = ''
      this.searchMakeDateFrom = ''
      this.searchMakeDateTo = ''
      this.searchDisplay = '表示'
      this.searchAnkenFlg = ['1', '3', '1.5']
      this.searchUnit = ''
      this.searchFacilityCode = ''
      this.searchFacilityName = ''
      this.searchMainShape = []
      this.searchGuestShape = []
      this.searchUpdateDateFrom = ''
      this.searchUpdateDateTo = ''
      this.searchConstructionDateFrom = ''
      this.searchConstructionDateTo = ''
    },
    resetProjects () {
      this.projectData = []
      this.projectLength = 0
      this.pageStart = 0
      this.pageEnd = 0
    },
    setActiveProjectList: async function () {
      this.pageStart = (this.page - 1) * this.pageMaxNum
      // pageが大きすぎる場合は表示可能になるまで減らす
      for (;this.page > 0;) {
        if (this.projectLength < this.pageStart) {
          this.page -= 1
          this.pageStart = (this.page - 1) * this.pageMaxNum
        } else {
          break
        }
      }

      this.pageEnd = this.pageStart + this.pageMaxNum
      if (this.projectLength < this.pageEnd) {
        this.pageEnd = this.pageStart + (this.projectLength % this.pageMaxNum)
      }
      this.activeProjectList = this.projectData['specs']['records'].slice(this.pageStart, this.pageEnd)

      localStorage.setItem('nowProjectListPage', this.page)
    },
    specRegist () {
      this.$router.push({
        name: 'ControlSpecRegistration',
        query: { mode: 'regist' }
      })
    },
    specChange (projectNumber) {
      this.$router.push({
        name: 'ControlSpecRegistration',
        query: { mode: 'confirmation', projectNumber: projectNumber }
      })
    },
    changeToggle (index) {
      if (!document.getElementById('toggle-display' + index).checked) {
        document.getElementById('toggle-display' + index).checked = true
        this.$refs.commonModalUpdateCancel.msgBoxConfirm('非表示になると、打合せ画面で提案できません。よろしいですか？', index)
      } else {
        let projectNumber = document.getElementById('project-number' + index).value
        this.specUpdate(projectNumber, '売上日報完了')
        document.getElementById('toggle-display' + index).checked = true
        this.changeToggleUpdateProjectData(projectNumber, '売上日報完了')
      }
    },
    changeToggleUpdateProjectData (projectNumber, updateStatus) {
      // ProjectDataは検索時に取得したデータ群
      // indexは画面上でソートしたactiveProjectListのindexのため、画面上のどの行がProjectDataの行か導けない
      // そのため、一意となるprojectNumberで検索を行う
      for (let i = 0; i < this.projectData['specs']['records'].length; ++i) {
        if (this.projectData['specs']['records'][i + (this.page - 1) * this.pageMaxNum]['レコード番号']['value'] === projectNumber) {
          this.projectData['specs']['records'][i + (this.page - 1) * this.pageMaxNum]['案件ステータス']['value'] = updateStatus
          break
        }
      }
    },
    specUpdateCancel (index) {
      if (!index) {
        index = 0
      }
      let projectNumber = document.getElementById('project-number' + index).value
      this.specUpdate(projectNumber, 'キャンセル')
      this.changeToggleUpdateProjectData(projectNumber, 'キャンセル')
    },
    specUpdate: async function (projectNumber, updateStatus) {
      let param = {'projectNumber': projectNumber}
      param['案件ステータス'] = {'value': updateStatus}
      const result = await SpecListModel.postApi(this.$bvModal, param, () => {})
      console.log(result)
      if (result['status'] !== 'success') {
        console.log('スペック情報更新失敗')
      } else {
        // 画面に表示されている一覧を検索した時の入力値に戻して再検索
        // await this.pageBackDataSetUp()
        // this.searchSpec(this.page, false, false)
      }
    },
    refreshToggel () {
      for (let i = 0; i < this.activeProjectList.length; ++i) {
        let toggle = document.getElementById('toggle-display' + i)
        if (toggle) {
          toggle.checked = (this.activeProjectList[i]['案件ステータス']['value'] === '売上日報完了')
        }
      }
    },
    clickCallback (pageNum) {
      this.page = pageNum // pageNumはpagerの何番目をclickしたかを取得
      this.setActiveProjectList()
      this.sortKeep()
      this.refreshToggel()
    },
    pageBackDataSetUp: async function () {
      const searchSpecConditions = JSON.parse(localStorage.getItem('searchSpecConditions'))
      console.log(searchSpecConditions)
      if (searchSpecConditions) {
        for (const [key, value] of Object.entries(searchSpecConditions)) {
          if (key === 'project-number') {
            this.searchProjectNumber = value.trim()
          } else if (key === 'style') {
            this.searchStyle = value
          } else if (key === 'color') {
            this.searchColor = value
          } else if (key === 'season') {
            this.searchSeason = value
          } else if (key === 'main-price-from') {
            this.searchMainPriceFrom = value
          } else if (key === 'main-price-to') {
            this.searchMainPriceTo = value
          } else if (key === 'guest-price-from') {
            this.searchGuestPriceFrom = value
          } else if (key === 'guest-price-to') {
            this.searchGuestPriceTo = value
          } else if (key === 'make-date-from') {
            this.searchMakeDateFrom = value
          } else if (key === 'make-date-to') {
            this.searchMakeDateTo = value
          } else if (key === 'display') {
            this.searchDisplay = value
          } else if (key === 'ankenFlg') {
            this.searchAnkenFlg = value
          } else if (key === 'unit') {
            this.searchUnit = value
          } else if (key === 'facilityCode') {
            this.searchFacilityCode = value
          } else if (key === 'facilityName') {
            this.searchFacilityName = value
          } else if (key === 'mainShape') {
            this.searchMainShape = value
          } else if (key === 'guestShape') {
            this.searchGuestShape = value
          } else if (key === 'update-date-from') {
            this.searchUpdateDateFrom = value
          } else if (key === 'update-date-to') {
            this.searchUpdateDateTo = value
          } else if (key === 'construction-date-from') {
            this.searchConstructionDateFrom = value
          } else if (key === 'construction-date-to') {
            this.searchConstructionDateTo = value
          }
        }
      }
    },
    sortSet (key, sortType = 'asc', type = 'str') {
      this.overlaySpecListShow = true

      let ProjectList = this.activeProjectList
      this.activeProjectList = []
      setTimeout(() => {
        let trueSort = 1 // 降順ソート
        let folseSort = -1 // 降順ソート
        if (sortType !== 'desc') {
          trueSort = -1 // 昇順ソート
          folseSort = 1 // 昇順ソート
        }
        if (type === 'num') {
          ProjectList = ProjectList.sort(function (a, b) {
            return (Number(a[key]['value']) < Number(b[key]['value'])) ? trueSort : folseSort
          })
        } else {
          ProjectList = ProjectList.sort(function (a, b) {
            return (a[key]['value'] < b[key]['value']) ? trueSort : folseSort
          })
        }
      }, 100)
      this.activeProjectList = ProjectList
      this.overlaySpecListShow = false
    },
    sortBy (key, type = 'str') {
      this.iniSortDirection(key)
      this.sortSet(key, this.getSortDirection(key), type)
    },
    sortKeep () {
      if (this.projectNumberSortDirection !== '') {
        this.sortSet('レコード番号', this.projectNumberSortDirection)
      }
      if (this.styleSortDirection !== '') {
        this.sortSet('スタイル', this.styleSortDirection)
      }
      if (this.colorSortDirection !== '') {
        this.sortSet('色', this.colorSortDirection)
      }
      if (this.seasonSortDirection !== '') {
        this.sortSet('季節', this.seasonSortDirection)
      }
      if (this.mainPriceSortDirection !== '') {
        this.sortSet('メインテーブル合計金額', this.mainPriceSortDirection, 'num')
      }
      if (this.guestPriceSortDirection !== '') {
        this.sortSet('ゲストテーブル合計金額', this.guestPriceSortDirection, 'num')
      }
      if (this.makeDateSortDirection !== '') {
        this.sortSet('作成日時', this.makeDateSortDirection)
      }
      if (this.displaySortDirection !== '') {
        this.sortSet('案件ステータス', this.displaySortDirection)
      }
      if (this.ankenFlgSortDirection !== '') {
        this.sortSet('案件フラグ', this.ankenFlgSortDirection)
      }
      if (this.mainShapeSortDirection !== '') {
        this.sortSet('メイン形状', this.mainShapeSortDirection)
      }
      if (this.guestShapeSortDirection !== '') {
        this.sortSet('ゲスト形状', this.guestShapeSortDirection)
      }
      if (this.constructionDateSortDirection !== '') {
        this.sortSet('施工日', this.constructionDateSortDirection)
      }
      if (this.facilityCodeAndNameSortDirection !== '') {
        this.sortSet('施設コード', this.facilityCodeAndNameSortDirection)
      }
      if (this.updateDateSortDirection !== '') {
        this.sortSet('更新日時', this.updateDateSortDirection)
      }
    },
    getSortDirection (key) {
      if (key === 'レコード番号') {
        if (this.projectNumberSortDirection !== 'desc') {
          this.projectNumberSortDirection = 'desc'
        } else {
          this.projectNumberSortDirection = 'asc'
        }
        return this.projectNumberSortDirection
      }
      if (key === 'スタイル') {
        if (this.styleSortDirection !== 'desc') {
          this.styleSortDirection = 'desc'
        } else {
          this.styleSortDirection = 'asc'
        }
        return this.styleSortDirection
      }
      if (key === '色') {
        if (this.colorSortDirection !== 'desc') {
          this.colorSortDirection = 'desc'
        } else {
          this.colorSortDirection = 'asc'
        }
        return this.colorSortDirection
      }
      if (key === '季節') {
        if (this.seasonSortDirection !== 'desc') {
          this.seasonSortDirection = 'desc'
        } else {
          this.seasonSortDirection = 'asc'
        }
        return this.seasonSortDirection
      }
      if (key === 'メインテーブル合計金額') {
        if (this.mainPriceSortDirection !== 'desc') {
          this.mainPriceSortDirection = 'desc'
        } else {
          this.mainPriceSortDirection = 'asc'
        }
        return this.mainPriceSortDirection
      }
      if (key === 'ゲストテーブル合計金額') {
        if (this.guestPriceSortDirection !== 'desc') {
          this.guestPriceSortDirection = 'desc'
        } else {
          this.guestPriceSortDirection = 'asc'
        }
        return this.guestPriceSortDirection
      }
      if (key === '作成日時') {
        if (this.makeDateSortDirection !== 'desc') {
          this.makeDateSortDirection = 'desc'
        } else {
          this.makeDateSortDirection = 'asc'
        }
        return this.makeDateSortDirection
      }
      if (key === '案件ステータス') {
        if (this.displaySortDirection !== 'desc') {
          this.displaySortDirection = 'desc'
        } else {
          this.displaySortDirection = 'asc'
        }
        return this.displaySortDirection
      }
      if (key === '案件フラグ') {
        if (this.ankenFlgSortDirection !== 'desc') {
          this.ankenFlgSortDirection = 'desc'
        } else {
          this.ankenFlgSortDirection = 'asc'
        }
        return this.ankenFlgSortDirection
      }
      if (key === 'メイン形状') {
        if (this.mainShapeSortDirection !== 'desc') {
          this.mainShapeSortDirection = 'desc'
        } else {
          this.mainShapeSortDirection = 'asc'
        }
        return this.mainShapeSortDirection
      }
      if (key === 'ゲスト形状') {
        if (this.guestShapeSortDirection !== 'desc') {
          this.guestShapeSortDirection = 'desc'
        } else {
          this.guestShapeSortDirection = 'asc'
        }
        return this.guestShapeSortDirection
      }
      if (key === '施工日') {
        if (this.constructionDateSortDirection !== 'desc') {
          this.constructionDateSortDirection = 'desc'
        } else {
          this.constructionDateSortDirection = 'asc'
        }
        return this.constructionDateSortDirection
      }
      if (key === '施設コード') {
        if (this.facilityCodeAndNameSortDirection !== 'desc') {
          this.facilityCodeAndNameSortDirection = 'desc'
        } else {
          this.facilityCodeAndNameSortDirection = 'asc'
        }
        return this.facilityCodeAndNameSortDirection
      }
      if (key === '更新日時') {
        if (this.updateDateSortDirection !== 'desc') {
          this.updateDateSortDirection = 'desc'
        } else {
          this.updateDateSortDirection = 'asc'
        }
        return this.updateDateSortDirection
      }
    },
    iniSortDirection (key = '') {
      if (key !== 'レコード番号') {
        this.projectNumberSortDirection = ''
      }
      if (key !== 'スタイル') {
        this.styleSortDirection = ''
      }
      if (key !== '色') {
        this.colorSortDirection = ''
      }
      if (key !== '季節') {
        this.seasonSortDirection = ''
      }
      if (key !== 'メインテーブル合計金額') {
        this.mainPriceSortDirection = ''
      }
      if (key !== 'ゲストテーブル合計金額') {
        this.guestPriceSortDirection = ''
      }
      if (key !== '作成日時') {
        this.makeDateSortDirection = ''
      }
      if (key !== '案件ステータス') {
        this.displaySortDirection = ''
      }
      if (key !== '案件フラグ') {
        this.ankenFlgSortDirection = ''
      }
      if (key !== 'メイン形状') {
        this.mainShapeSortDirection = ''
      }
      if (key !== 'ゲスト形状') {
        this.guestShapeSortDirection = ''
      }
      if (key !== '施工日') {
        this.constructionDateSortDirection = ''
      }
      if (key !== '施設コード') {
        this.facilityCodeAndNameSortDirection = ''
      }
      if (key !== '更新日時') {
        this.updateDateSortDirection = ''
      }
    },
    strSortDirection (key) {
      let keysort = ''
      if (key === '打合せ参加ID') {
        keysort = this.projectNumberSortDirection
      } else if (key === 'スタイル') {
        keysort = this.styleSortDirection
      } else if (key === '色') {
        keysort = this.colorSortDirection
      } else if (key === '季節') {
        keysort = this.seasonSortDirection
      } else if (key === 'メインテーブル合計金額') {
        keysort = this.mainPriceSortDirection
      } else if (key === 'ゲストテーブル合計金額') {
        keysort = this.guestPriceSortDirection
      } else if (key === '作成日時') {
        keysort = this.makeDateSortDirection
      } else if (key === '状態') {
        keysort = this.displaySortDirection
      } else if (key === '案件フラグ') {
        keysort = this.ankenFlgSortDirection
      } else if (key === 'メイン形状') {
        keysort = this.mainShapeSortDirection
      } else if (key === 'ゲスト形状') {
        keysort = this.guestShapeSortDirection
      } else if (key === '施工日') {
        keysort = this.constructionDateSortDirection
      } else if (key === '施設コード') {
        keysort = this.facilityCodeAndNameSortDirection
      } else if (key === '更新日時') {
        keysort = this.updateDateSortDirection
      }
      if (keysort === 'asc') {
        return ' ▲'
      }
      if (keysort === 'desc') {
        return ' ▼'
      }
      return ''
    },
    setUserRoleMode () {
      const roleMode = {
        'システム管理者': 2,
        '運用管理者': 2,
        '本部マネージャー': 2,
        'エリアマネージャー': 1,
        'ユニットリーダー': 1,
        'チームリーダー': 1,
        'メンバー': 1,
        'プランナー': 0
      }
      this.userRoleMode = (this.userRole in roleMode) ? roleMode[this.userRole] : 0
    },
    autoChangeFacility: async function (e) {
      this.overlayShow = true
      console.log(e.target.value)

      const param = {
        'facilityCode': e.target.value
      }
      const result = await SearchFacilityModel.getApi(this.$bvModal, param, (result) => {})
      console.log(result)
      if ('records' in result && result['records'].length > 0) {
        this.searchFacilityName = result['records'][0]['施設名']['value']
      } else {
        this.searchFacilityName = ''
      }
      this.overlayShow = false
    },
    changeToShapeName (data, type) {
      let strShapeData = ''
      if (type === 'main') {
        for (const i in this.mainShapeData) {
          if (data.includes('"' + this.mainShapeData[i]['value'] + '"')) {
            strShapeData += this.mainShapeData[i]['label'] + '\n'
          }
        }
        if (strShapeData !== '') {
          strShapeData = strShapeData.slice(0, strShapeData.length - 1)
        }
      } else {
        for (const i in this.guestShapeData) {
          if (data.includes('"' + this.guestShapeData[i]['value'] + '"')) {
            strShapeData += this.guestShapeData[i]['label'] + '\n'
          }
        }
        if (strShapeData !== '') {
          strShapeData = strShapeData.slice(0, strShapeData.length - 1)
        }
      }
      return strShapeData
    }
  },
  mounted () {
    this.setApiData()
  }
}
</script>
<style>
.white-line {
  background-color: #fff;
}
.white-line:hover {
  background-color: #d9efff !important;
}
.gray-line {
  background-color: #eefdff;
}
.gray-line:hover {
  background-color: #d9efff !important;
}
.tile-image-height {
  max-height: 140px;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/ControlSpecList.vue